import { styled, Typography } from "@mui/material";
import { FlaskIcon } from "@phosphor-icons/react/dist/csr/Flask";
import { FlowArrowIcon } from "@phosphor-icons/react/dist/csr/FlowArrow";
import { StarFourIcon } from "@phosphor-icons/react/dist/csr/StarFour";

const PurposeTypography = styled(Typography)({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  marginLeft: "4px",
});

const PurposeCell = ({ purpose }: { purpose?: string | null }) => {
  switch (purpose) {
    case "backfill":
      return (
        <>
          <FlowArrowIcon height="16px" width="16px" style={{ flexShrink: 0 }} />
          <PurposeTypography variant="body.small.regular">Backfill</PurposeTypography>
        </>
      );
    case "proof":
      return (
        <>
          <FlaskIcon height="16px" width="16px" style={{ flexShrink: 0 }} />
          <PurposeTypography variant="body.small.regular">Test</PurposeTypography>
        </>
      );
    case "production":
      return (
        <>
          <StarFourIcon height="16px" width="16px" style={{ flexShrink: 0 }} />
          <PurposeTypography variant="body.small.regular">Published</PurposeTypography>
        </>
      );
    default:
      return null;
  }
};

export { PurposeCell };
